import { scoreBreakdown } from "@ravalmatic/bridge-engine/core";
import type { Contract } from "@ravalmatic/bridge-engine/core";
import type { MatchState } from "../../Types";

export function scoreRubberHand(match: MatchState, contract: Contract | null, declarerTricks = 0): void {

    if (match.northSouth.gamesWon >= 2 || match.eastWest.gamesWon >= 2) {
        throw new Error("Cannot score another hand after the rubber has ended");
    }
    if (contract && (!Number.isInteger(declarerTricks) || declarerTricks < 0 || declarerTricks > 13)) {
        throw new Error(`Invalid Rubber declarer trick count: ${declarerTricks}`);
    }
    const current = match.rubber.currentGame;
    current.handCount++;
    if (!contract) {
        return;
    }
    const declaring = contract.declarer % 2 === 0 ? "northSouth" : "eastWest";
    const defending = declaring === "northSouth" ? "eastWest" : "northSouth";
    // Engine receipts use exclusive double/redouble flags for their multipliers.
    const normalized = { ...contract, doubled: contract.doubled && !contract.redoubled };
    const receipt = scoreBreakdown(normalized, {
        ns: match.northSouth.vulnerable, ew: match.eastWest.vulnerable
    }, declarerTricks);
    const lines = receipt.lines.filter(line => line.kind !== "game-bonus" && line.kind !== "partscore-bonus");
    const award = lines.reduce((sum, line) => sum + line.amount, 0);
    const recipient = award < 0 ? defending : declaring;
    match[recipient].totalPoints += Math.abs(award);
    current.points[recipient] += Math.abs(award);
    const contractPoints = lines.find(line => line.kind === "odd-tricks")?.amount ?? 0;
    match[declaring].gamePoints += contractPoints;
    if (match[declaring].gamePoints < 100) {
        return;
    }
    match.rubber.games.push({
        handCount: current.handCount,
        winningPartnership: declaring,
        contractPoints: {
            northSouth: match.northSouth.gamePoints, eastWest: match.eastWest.gamePoints
        },
        points: { ...current.points }
    });
    match[declaring].gamesWon++;
    match[declaring].vulnerable = true;
    match.northSouth.gamePoints = 0;
    match.eastWest.gamePoints = 0;
    match.rubber.currentGame = { handCount: 0, points: { northSouth: 0, eastWest: 0 } };
    if (match[declaring].gamesWon === 2) {
        match[declaring].totalPoints += match[defending].gamesWon === 0 ? 700 : 500;
    }
}
